export const siteUrl = (process.env.REACT_APP_SITE_URL || "https://titiksenyapstudio.id").replace(/\/$/, "");
export const pageMetadata = {
  "/": {
    title: "Titik Senyap Studio | Produk Digital & Jasa Foto Video AI",
    description: "Kenali produk Titik Senyap Studio: AI Photo & Video, Starvy, Danusan, dan Bot Anjem UNNES. Layanan desain, website, aplikasi, serta konten AI untuk promosi produk.",
  },
  "/catalog": {
    title: "Katalog Layanan Digital | Titik Senyap Studio",
    description: "Lihat paket dan harga layanan website, aplikasi mobile, desain UI/UX, game Roblox, dan AR dari Titik Senyap Studio. Konsultasi dan pesan melalui WhatsApp.",
  },
  "/ai-photo-video": {
    title: "Jasa Foto & Video AI untuk Affiliate dan Konten | Titik Senyap Studio",
    description: "Pesan jasa foto produk AI dan video AI untuk affiliate TikTok, Shopee, Reels, katalog UMKM, serta promosi brand. Pilih konsep dan pesan langsung melalui form Flow.",
  },
};

export const englishPageMetadata = {
  "/": {
    title: "Titik Senyap Studio | Digital Products & AI Photo Video Services",
    description: "Discover Titik Senyap Studio products: AI Photo & Video, Starvy, Danusan, and Bot Anjem UNNES. Design, web, app development, and AI content for product promotion.",
  },
  "/catalog": {
    title: "Digital Service Catalog | Titik Senyap Studio",
    description: "Explore packages and prices for website development, mobile apps, UI/UX, Roblox games, and AR by Titik Senyap Studio. Consult and order through WhatsApp.",
  },
  "/ai-photo-video": {
    title: "AI Photo & Video Services for Affiliates and Content | Titik Senyap Studio",
    description: "Order AI product photos and videos for TikTok and Shopee affiliates, Reels, small-business catalogs, and brand promotion. Choose a concept and order through Flow.",
  },
};
export function getPageMetadata(route, language) {
  const pages = language === "en" ? englishPageMetadata : pageMetadata;
  return pages[route] || pages["/"];
}
